export const projects = [
    {
        id: 1,
        title: 'مدیریت کریپتو',
        date: '29 آدر 1401',
        leader: 'روبرت',
        members: [
            '/images/avatars/1.png',
            '/images/avatars/2.png',
            '/images/avatars/4.png',
            '/images/avatars/5.png',
        ],
        status: '36%',
        icon: '/images/icons/html-label.png'
    },
    {
        id: 2,
        title: 'قالب مدیریت',
        date: '06 شهریور 1401',
        leader: 'استیو',
        members: [
            '/images/avatars/4.png',
            '/images/avatars/5.png',
            '/images/avatars/6.png',
        ],
        status: '100%',
        icon: '/images/icons/vue-label.png'
    },
    {
        id: 3,
        title: 'طراحی لوگو',
        date: '12 تیر 1401',
        leader: 'کیت',
        members: [
            '/images/avatars/1.png',
            '/images/avatars/2.png',
            '/images/avatars/5.png',
            '/images/avatars/6.png',
        ],
        status: '92%',
        icon: '/images/icons/sketch-label.png'
    },
    {
        id: 4,
        title: 'طراحی برنامه',
        date: '09 فروردین 1401',
        leader: 'آلفرد',
        members: [
            '/images/avatars/1.png',
            '/images/avatars/2.png',
            '/images/avatars/4.png',
        ],
        status: '89%',
        icon: '/images/icons/xd-label.png'
    },
    {
        id: 5,
        title: 'طراحی برنامه IOS',
        date: '19 دی 1401',
        leader: 'جانی',
        members: [
            '/images/avatars/1.png',
            '/images/avatars/2.png',
            '/images/avatars/6.png',
        ],
        status: '65%',
        icon: '/images/icons/sketch-label.png'
    },
]


// icon, title, caption, customerName, startDate, endDate, totalPrice, received, leftDays, totalTime, goneTime ,tasksDone , completePercent, tasks, members, comments
export const allProjects = [
    {
        id: 1,
        icon:'/images/icons/social-label.png',
        title: 'بنرهای اجتماعی',
        caption: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده',
        customerName: 'لیونل مسی',
        startDate: '1403/04/05',
        endDate: '1404/10/12',
        totalPrice: 46768,
        received: 43566,
        leftDays: 5,
        totalTime: 135,
        goneTime: 45,
        tasksDone: 43,
        completePercent: '95%',
        tasks: 76,
        members: [
            '/images/avatars/1.png',
            '/images/avatars/4.png',
        ],
        comments: 41

    },
    {
        id: 2,
        icon:'/images/icons/react-label.png',
        title: 'قالب مدیریت',
        caption: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده',
        customerName: 'بیل گیتس',
        startDate: '1403/04/05',
        endDate: '1404/10/12',
        totalPrice: 123985,
        received: 56789,
        leftDays: 54,
        totalTime: 167,
        goneTime: 65,
        tasksDone: 57,
        completePercent: '88%',
        tasks: 54,
        members: [
            '/images/avatars/1.png',
            '/images/avatars/4.png',
            '/images/avatars/9.png',
        ],
        comments: 32

    },
    {
        id: 3,
        icon:'/images/icons/vue-label.png',
        title: 'طراحی برنامه',
        caption: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده',
        customerName: 'املیا کلارک',
        startDate: '1403/04/05',
        endDate: '1404/10/12',
        totalPrice: 165937,
        received: 78436,
        leftDays: 120,
        totalTime: 146,
        goneTime: 34,
        tasksDone: 87,
        completePercent: '34%',
        tasks: 78,
        members: [
            '/images/avatars/5.png',
            '/images/avatars/9.png',
            '/images/avatars/10.png',
        ],
        comments: 45

    },
    {
        id: 4,
        icon:'/images/icons/html-label.png',
        title: 'طراحی وبسایت',
        caption: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده',
        customerName: 'جان اسنو',
        startDate: '1403/04/05',
        endDate: '1404/10/12',
        totalPrice: 198347,
        received: 67938,
        leftDays: 124,
        totalTime: 123,
        goneTime: 12,
        tasksDone: 12,
        completePercent: '12%',
        tasks: 148,
        members: [
            '/images/avatars/1.png',
            '/images/avatars/4.png',
            '/images/avatars/9.png',
            '/images/avatars/12.png',
        ],
        comments: 4

    },
    {
        id: 5,
        icon:'/images/icons/figma-label.png',
        title: 'طراحی لوگو',
        caption: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده',
        customerName: 'پیتر پارکر',
        startDate: '1403/04/05',
        endDate: '1404/10/12',
        totalPrice: 245987,
        received: 34567,
        leftDays: 32,
        totalTime: 88,
        goneTime: 24,
        tasksDone: 43,
        completePercent: '76%',
        tasks: 138,
        members: [
            '/images/avatars/14.png',
            '/images/avatars/4.png',
            '/images/avatars/9.png',
            '/images/avatars/10.png',
        ],
        comments: 12

    },
    {
        id: 6,
        icon:'/images/icons/xd-label.png',
        title: 'توسعه نرم افزار',
        caption: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده',
        customerName: 'دیوید بکام',
        startDate: '1403/04/05',
        endDate: '1404/10/12',
        totalPrice: 176242,
        received: 23985,
        leftDays: 12,
        totalTime: 135,
        goneTime: 45,
        tasksDone: 87,
        completePercent: '56%',
        tasks: 125,
        members: [
            '/images/avatars/9.png',
            '/images/avatars/10.png',
        ],
        comments: 24

    },
]